<template>
    <v-form
        ref="keyform"
        v-if="items"
        v-model="keyForm"
        @submit="onKeyFormSubmit"
        :disabled="is_disabled">

        <div
            v-for="(item) in itemKeys"
            :key="item.id">
            <v-hover v-slot:default="{ hover }">
                <v-row
                    align="center"
                    :class="{'grey lighten-5 pb-3' : isMultiple}"
                    v-if="!item.adminOnly || isSuperAdmin">

                    <!-- key type -->
                    <v-col cols="12" md="4" lg="3">
                        <v-text-field
                            v-model="item.key_type"
                            type="text"
                            label="Key Type"
                            :readonly="isFieldDisable(item)"
                            :rules="[v => !!v || 'Key type is required']">
                        </v-text-field>
                    </v-col>

                    <!-- key data -->
                    <v-col cols="12" md="4" lg="3">
                        <v-text-field
                            v-model="item.key_data"
                            type="text"
                            label="Key Data"
                            :rules="item.optional ? [] : [v => !!v || 'Key data is required']"
                            :readonly="is_disabled">
                        </v-text-field>
                    </v-col>

                    <!-- key expiry -->
                    <v-col cols="12" md="3" lg="3">
                        <v-menu
                            v-model="item.showDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :disabled="is_disabled">
                            <template v-slot:activator="{ on }">
                                <!-- date -->
                                <v-text-field
                                    v-model="item.expiry"
                                    label="Expiry date"
                                    prepend-icon="event"
                                    clearable
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="item.expiry" @input="item.showDate = false"></v-date-picker>
                        </v-menu>
                        <!-- <span class="ic-remove clickable" @click="onRemoveKey(item, optIndex)">
                            <i class="fa fa-times-circle fa-2x"></i>
                        </span> -->
                    </v-col>
                    <v-col v-if="isMultiple" md="1" sm="2" class="ml-auto text-right">
                        <span class="ic-remove clickable" @click="onRemove(item)">
                            <i class="fa fa-times-circle fa-2x"></i>
                        </span>

                    </v-col>
                </v-row>
            </v-hover>
        </div>

        <Modal
            ref="modal"
            color="error"
            okText="delete" />
    </v-form>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Modal from '~/Modal'

export default {
    components: {
        Modal
    },

    props: {
        integrationId: { type: Number, default: null },
        formItems:     { type: Array, default: null },
        isMultiple:    { type: Boolean, default: false },
        is_disabled:   { type: Boolean, default: false }
    },

    data() {
        return {
            // machship key form
            keyForm: false,
            items: this.formItems,
            isSubmitting: false,

            fixedKeys: [
                'machship_token',
                'test_machship_token',
                // 'admin_machship_token'
            ],
        }
    },

    watch: {
        // because we need to update whats new to keys
        formItems(newval, oldval) {
            if (newval != oldval) {
                this.items = newval;
            }
        }
    },

    computed: {
        itemKeys() {

            let itemKeys = this.items.map(key => {
                if (key.expiry != '' && key.expiry != null) {
                    key.expiry = moment(key.expiry).format('YYYY-MM-DD')
                }

                if (
                    key.key_type === 'test_machship_token'
                ) {
                    key.optional = true;
                }

                // if (key.key_type === 'admin_machship_token') {
                //     key.adminOnly = true;
                // }

                return key
            })
            return itemKeys
        },

        ...mapGetters([
            'isAdmin',
            'isSuperAdmin'
        ])
    },

    methods: {
        onRemoveConfirm(itemKey) {
            if (this.isMultiple) {
                let index = this.items.findIndex(item => item == itemKey)
                this.items.splice(index, 1)
            }

            if (Number.isInteger(itemKey.id)) {
                this.$http
                    .delete('/api/integrationkeys/' + itemKey.id)
                    .then(() => {
                        EventBus.$emit('show-success', 'Successfully deleted integration key.');
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                    })
            }
        },
        onRemove(itemKey) {

            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete this key?',
                () => this.onRemoveConfirm(itemKey)
            );
        },

        onKeyFormSubmit() {

            // stops from spamming
            if (this.isSubmitting) {
                return resolve();
            }

            // check item keys input
            if (this.itemKeys == null || this.itemKeys.length == 0) {
                return resolve();
            }

            return new Promise((resolve) => {

                // allow background to process before proceeding on update
                setTimeout(() => {

                    let keydata = this.itemKeys.filter(key => key.key_data !== null && key.key_data !== '')

                    if (this.$refs.keyform.validate()) {
                        this.$http
                            .post('/api/integrationkeys/bulk', keydata)
                            .then(({ data }) => {
                                EventBus.$emit('show-success', 'Successfully saved integrations.')
                                this.isSubmitting = false
                                resolve(data);
                            })
                            .catch(err => {
                                EventBus.$emit('show-error', err)
                                this.isSubmitting = false
                                resolve();
                            })
                    }

                }, 500);

            })
        },

        onKeyFormAddMore() {
            this.items.push({
                key_type: '',
                key_data: '',
                expiry: '',
                showDate: false,
                integration_id: this.integrationId
            })
        },

        isFieldDisable(item) {
            return this.fixedKeys.findIndex(key => item.key_type == key) >= 0
        }
    }
}
</script>